module.exports = __webpack_public_path__ + "f5ffce008234ff24d54ab0c52d027f2d.pdf";